// Environment-specific base URLs
const BASE_URLS = {
  dev: 'https://publicfilesdev.ohiosos.gov/election-results',
  uat: 'https://publicfilesuat.ohiosos.gov/election-results',
  prod: 'https://publicfiles.ohiosos.gov/election-results'
};

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'dev';
//delete later 
console.log('🔧 Environment Configuration:', {
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  ENVIRONMENT: ENVIRONMENT,
  BASE_URL: BASE_URLS[ENVIRONMENT]
});

/**
 * Builds the public download URL from a blob path tag
 * @param {string} blobPath - The path from JSON 
 * @returns {string} - public URL
 */
export const getDownloadUrl = (blobPath) => {
  const baseUrl = BASE_URLS[ENVIRONMENT];
  
  const cleanPath = blobPath.startsWith('/') ? blobPath.slice(1) : blobPath;
  
  // For local development, use the mock JSON structure
//   if (ENVIRONMENT === 'development') {
//     return `/${cleanPath}`; // Serve from public folder
//   }
  
  return `${baseUrl}/${cleanPath}`;
};

/**
 * Gets the JSON index file
 * @returns {string} 
 */
export const getJsonUrl = () => {
  if (ENVIRONMENT === 'prod') {
    return 'https://publicfiles.ohiosos.gov/election-results/files-index.json';
  } else if (ENVIRONMENT === 'uat') {
    return 'https://publicfilesuat.ohiosos.gov/election-results/files-index.json';
  } else if (ENVIRONMENT === 'dev') {
    return 'https://publicfilesdev.ohiosos.gov/election-results/files-index.json';
  }else {
    return '/election-results-mock.json'; // Local development
  }
};

/**
 * Initiates a file download
 * @param {string} blobPath
 * @param {string} displayName 
 */
export const downloadFile = (blobPath, displayName) => {
  const url = getDownloadUrl(blobPath);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', displayName);
  link.setAttribute('target', '_blank'); 
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};